module.exports = __webpack_public_path__ + "static/img/pay-yue.96bb41a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pay-yue.png
// module id = rcX9
// module chunks = 171